import { FC } from "react";
import StrengthsWeaknesses from "@components/StrengthsWeaknesses/StrengthsWeaknesses";
import BrandsHeader from "../BrandsHeader/BrandsHeader";
import "./BrandsParties.styles.scss";
import { components } from "@apiSchema";

interface iProps {
    data: components['schemas']['FPChainData'];
}

const BrandsParties: FC<iProps> = (
    {
        data: {
            situationAssessmentData,
        },
    }
) => {
    const {
        strengths,
        weakness,
    } = situationAssessmentData ?? {};

    return (
        <div className="BrandsParties">
            <BrandsHeader title="Strengths & Weaknesses" classNames="is-lead"/>

            <StrengthsWeaknesses
                strengths={(strengths ?? []).map((el) => el.name ?? '')}
                weaknesses={(weakness ?? []).map((el) => el.name ?? '')}
                valueClassName="Brands__blur"
            />
        </div>
    );
};

export default BrandsParties;
